export class UIError {
    constructor(
        public ErrorObject : any = '', 
        public  Url : string = '') {}
}



// WEBPACK FOOTER //
// ./src/app/models/uiError.model.ts